export default {
    GET_OUTDOORS_LOCALIZATION_TEAMS_REQUEST: state => {
        state.outdoorsLocalizationTeamsLoading = true
    },
    GET_OUTDOORS_LOCALIZATION_TEAMS_SUCCESS: (state, data) => {
        state.outdoorsLocalizationTeams = data.results
        state.outdoorsLocalizationTeamsLoading = false
    },
    GET_OUTDOORS_LOCALIZATION_TEAMS_FAILURE: state => {
        state.outdoorsLocalizationTeamsLoading = false
    },
    SET_TEAMS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_TEAMS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}